"use client"

import { Badge as ChakraBadge } from "@chakra-ui/react"
import * as React from "react"

export interface BadgeProps extends React.ComponentProps<typeof ChakraBadge> {
  /**
   * The color scheme of the badge
   */
  colorScheme?:
    | "gray"
    | "red"
    | "orange"
    | "yellow"
    | "green"
    | "teal"
    | "blue"
    | "cyan"
    | "purple"
    | "pink"
  /**
   * The size of the badge
   */
  size?: "sm" | "md" | "lg"
  /**
   * The content of the badge
   */
  children?: React.ReactNode
}

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  function Badge(props, ref) {
    const { colorScheme = "gray", size = "md", children, ...rest } = props

    return (
      <ChakraBadge ref={ref} colorScheme={colorScheme} size={size} {...rest}>
        {children}
      </ChakraBadge>
    )
  },
)
